"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtons = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _defaultTranslations = require("../constants/defaultTranslations");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const ButtonSave = (0, _mui.styled)(_components.Button)(({
  theme,
  ownerState
}) => ({
  width: '100%',
  marginTop: theme.spacing(3),
  color: `${theme.palette.default.contrastText} !important`,
  ...(ownerState.disabled && {
    color: `${theme.palette.grey[500]} !important`
  })
}));
const ButtonCancel = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  width: '100%',
  marginTop: theme.spacing(3)
}));
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));
const ActionButtons = props => {
  const {
    isValid,
    isDirty,
    isTouchedForm,
    isSubmitting,
    isSubmitted,
    isEveryInvalidFieldTouched = true,
    dataTestIdPrefix = '',
    enableCancel = true,
    handleCancel,
    handleSave,
    currentCustomerId
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const globalApi = (0, _globalApiClientReact.useApiClient)();
  const selectedCustomerId = currentCustomerId ?? customerId;
  const {
    data: completenessMetadata
  } = (0, _globalApiClientReact.useGetCustomerProfileCompletenessMetadata)(selectedCustomerId, {}, {
    swr: {
      revalidateOnFocus: false
    }
  });
  const allowSaveButton = isDirty && !isEveryInvalidFieldTouched || isDirty && isValid;
  const saveButtonType = handleSave ? 'button' : 'submit';
  const saveButtonColor = allowSaveButton ? 'primary' : 'inherit';
  const saveButtonDisabled = allowSaveButton ? isSubmitting : true;
  const availableCompleteness = completenessMetadata?.isAvailable;
  const updateProfileCompleteness = (0, _react.useCallback)(async () => {
    await (0, _globalApiClientReact.getCustomerProfileCompleteness)(globalApi, selectedCustomerId);
  }, [selectedCustomerId, globalApi]);
  (0, _react.useEffect)(() => {
    if (isSubmitted && availableCompleteness) {
      updateProfileCompleteness();
    }
  }, [selectedCustomerId, updateProfileCompleteness, isSubmitted, availableCompleteness]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      maxWidth: "330px",
      width: "100%",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonSave, {
        fullWidth: true,
        type: saveButtonType,
        color: saveButtonColor,
        variant: "contained",
        disabled: saveButtonDisabled,
        "data-testid": getTestId(`${dataTestIdPrefix}-SaveButton`),
        ownerState: {
          disabled: saveButtonDisabled
        },
        onClick: handleSave ?? undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
          id: _models.TranslationKey.save,
          defaultMessage: _defaultTranslations.defaultTranslations.save
        })
      })
    }), isTouchedForm && enableCancel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      maxWidth: "330px",
      width: "100%",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonCancel, {
        variant: "text",
        "data-testid": getTestId(`${dataTestIdPrefix}-CancelButton`),
        onClick: handleCancel,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
          id: _models.TranslationKey.cancel,
          defaultMessage: _defaultTranslations.defaultTranslations.cancel
        })
      })
    }) : null]
  });
};
exports.ActionButtons = ActionButtons;
